import { BadgeV2 as Badge } from 'components'
import { BaseBadgeProps, dropdownBadges } from '../variants'

export type DropdownBadgeProps = {
  isDeletedView?: boolean
  isLoading?: boolean
  type: keyof typeof dropdownBadges
  value?: BaseBadgeProps['value']
}

const DropdownBadge = ({ isDeletedView, type, value, isLoading }: DropdownBadgeProps) => {
  const variant = dropdownBadges[type]?.find((p) => String(p.value) === String(value)) || dropdownBadges[type][0]
  return (
    <Badge lineHeight="20px" color={isDeletedView ? 'gray' : variant.color} text={variant.text} isLoading={isLoading} />
  )
}

export default DropdownBadge
